module.exports = {
      id: "newsletter-usage",
      viewBox: "0 0 26 23.012",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#newsletter",
      toString: function () {
        return this.url;
      }
    }